{
  "commonHeader": {
    "upgradeToPro": "Actualizar",
    "learnMore": "Más información",
    "AIProductivitySuite": {
      "title": "Suite de productividad de IA",
      "desc": "Convierta debates inspiradores en entregables impresionantes."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Administre la cuenta de su organización con IA",
        "description": "Obtenga respuestas inteligentes a sus preguntas sobre la cuenta y ayuda para navegar por la configuración.",
        "terms": "Al usar las funciones beta de Zoom, acepta {0}",
        "termsText": "los Términos del programa beta de Zoom"
      },
      "diveDeeper": "Profundizar",
      "shareFeedback": "Comparta comentarios en {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Pregunte sobre la cuenta de su organización",
      "heroInvite": "¿Cómo invito a un usuario nuevo a mi cuenta?",
      "heroGroups": "¿Cómo asigno usuarios a grupos?",
      "heroRoles": "Explíqueme cómo gestionar roles y permisos"
    },
    "backMainAccount": "Volver a la cuenta principal",
    "discoverProducts": "Descubrir productos",
    "pricing": "Precios",
    "more": "Más",
    "sidebarExpanded": "expandido",
    "sidebarCollapsed": "contraído",
    "search": "Buscar",
    "users": "Usuarios",
    "settings": "Configuración de la cuenta",
    "navigation": "Navegación",
    "clear": "Borrar",
    "searchPlaceholderAll": "Buscar usuarios, ajustes de la cuenta o navegación",
    "searchPlaceholderUsers": "Buscar usuarios o navegación",
    "searchPlaceholderSettings": "Buscar ajustes de la cuenta o navegación",
    "searchPlaceholderNav": "Buscar navegación",
    "searchGuide": "Escriba palabras clave para empezar a buscar",
    "installOnDesktop": "Instalar en el escritorio",
    "downloadCenter": "Centro de descargas",
    "getInTouch": "Póngase en contacto",
    "featuredProduct": "producto destacado",
    "logo": {
      "adminCenter": "Centro de administración",
      "subAccount": "Gestionando subcuenta",
      "externalAccount": "Gestionando cuenta delegada"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Más información",
      "gotIt": "Entendido"
    },
    "coachMark": {
      "dvsTipsTitle": "Las divisiones ya están disponibles",
      "dvsTipsContent": "Las divisiones se usan para crear varias instancias de determinados productos de Zoom en su cuenta."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Más información",
      "gotIt": "Entendido"
    },
    "coachMark": {
      "extAccountTipsTitle": "Administrar cuentas externas",
      "extAccountTipsContent": "¿Necesita administrar otra cuenta? Envíe una solicitud: cuando la aprueben, ¡ya podrá acceder!"
    }
  },
  "feedback": {
    "dialogTitle": "Dejar comentarios",
    "itemLableForProductArea": "Área de producto",
    "itemLableForSatisfied": "¿Cuál es su grado de satisfacción con su experiencia?",
    "dissatisfied": "Muy insatisfecho",
    "satisfied": "Muy satisfecho",
    "itemLableForFeedback": "Comentarios",
    "placeholder": "Gracias por sus ideas, comentarios y sugerencias.",
    "btnCancel": "Cancelar",
    "btnSubmit": "Enviar",
    "supportTips": "Para obtener soporte técnico, visite",
    "btnSupport": "Soporte.",
    "messages": {
      "success": "Gracias por sus comentarios",
      "productFailed": "El área de producto es obligatoria.",
      "scoreFailed": "La puntuación de satisfacción es obligatoria."
    },
    "products": {
      "General": "General",
      "AI": "IA",
      "Apps": "Apps",
      "Calendar": "Calendario",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Correo",
      "Meetings": "Reuniones",
      "Notes": "Notas",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Programador",
      "Tasks": "Tareas",
      "TeamChat": "Chat de equipo",
      "WebinarsAndEvents": "Seminarios web y eventos",
      "Whiteboard": "Pizarra",
      "WorkflowAutomations": "Automatizaciones de flujo de trabajo",
      "WorkspaceReservation": "Reserva de espacios de trabajo",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "El administrador de su cuenta ha generado este descargo de responsabilidad.",
    "cancel": "Cancelar",
    "agree": "De acuerdo"
  },
  "shared": {
    "sideMenu": {
      "personal": "Personal",
      "admin": "Administrador",
      "menu": "Menú",
      "pinned": "Anclado",
      "pin": "Anclar",
      "unpin": "Desanclar",
      "moveItem": "Mover elemento",
      "myAccount": "Mi cuenta",
      "upgradeToPro": "Actualizar a Pro",
      "grabbedKeyboard": "{0} agarrado. Use las flechas arriba y abajo para mover, espacio o Intro para soltar.",
      "dropped": "{0} soltado.",
      "releasedUnchanged": "{0} liberado, posición sin cambios.",
      "movedToPosition": "{0} movido a la posición {1} de {2}.",
      "movedUp": "{0} movido hacia arriba, posición {1} de {2}.",
      "movedDown": "{0} movido hacia abajo, posición {1} de {2}.",
      "movedUpNew": "{0} movido hacia arriba, nueva posición {1} de {2}",
      "movedDownNew": "{0} movido hacia abajo, nueva posición {1} de {2}",
      "cannotMoveFurther": "{0} no se puede mover más.",
      "grabbedMouse": "{0} agarrado. Mueva el ratón para reposicionar, haga clic para soltar, pulse Escape para cancelar."
    },
    "item": "Elemento",
    "gotIt": "Entendido",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "¡Número de teléfono añadido correctamente! Ya puede utilizarlo para iniciar sesión y recuperar la cuenta.",
    "mfa_to_signin_phone_success": "{phone} es ahora el número de inicio de sesión de {email}.",
    "login_passkey_bound_success": "La clave de acceso se ha creado con éxito."
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Las siguientes funciones de administración avanzada solo se aplicarán a los usuarios con licencia y de colaboración",
      "licensed_basic": "Las siguientes funciones de administración avanzada solo se aplicarán a los usuarios con licencia y básicos",
      "licensed": "Las siguientes funciones de administración avanzada solo se aplicarán a los usuarios con licencia"
    },
    "support": "- Compatible con la configuración de la cuenta y la configuración del grupo de usuarios",
    "archive_product": {
      "title": "Archivar reuniones y seminarios web",
      "detail": "- Las reuniones se archivarán cuando los usuarios de su cuenta se unan. Para utilizar esta configuración, instale una <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">aplicación de archivado</a> desde el Zoom App Marketplace."
    },
    "restrict": {
      "title": "Restringir a los usuarios el uso de funciones seleccionadas cuando se unan a una reunión",
      "detail": "- Las funciones seleccionadas no se pueden utilizar incluso si los anfitriones de la reunión las habilitan para las reuniones."
    },
    "meeting_integration": {
      "title": "Habilitar la integración de DLP (Prevención de pérdida de datos) en el chat durante la reunión",
      "detail": "- Cuando está activada, la DLP se aplicará a los mensajes de chat públicos y privados que envíe un participante. Los mensajes se eliminarán inmediatamente si los participantes de una reunión (interna o externa) están chateando y un mensaje infringe las políticas de cumplimiento de la organización del anfitrión."
    },
    "chat_tool": {
      "title": "Herramienta de etiqueta del chat",
      "detail": "- Identificar palabras clave y patrones de texto definidos en el contenido compartido, y evitar que los usuarios compartan mensajes no deseados"
    },
    "information_barriers": {
      "title": "Barreras de información",
      "detail": "- Las barreras de información controlan las comunicaciones entre determinados usuarios para fines de cumplimiento de normativa. Se pueden establecer restricciones en las reuniones y chat entre usuarios en dos grupos y en determinados usuarios para el uso de funciones específicas (es decir, chat durante la reunión, uso compartido de pantalla y transferencia de archivos). Estas restricciones evitan que se intercambie información confidencial entre usuarios no autorizados."
    },
    "dashboard": {
      "title": "Panel de control",
      "detail": "- Para las reuniones > en el panel de control de las reuniones anteriores, los datos se muestran solo durante 3 meses para algunos usuarios"
    },
    "reports": {
      "title": "Informes",
      "detail": "- Algunos informes de usuario muestran datos de solo 3 meses para algunos usuarios: informe de exención de responsabilidad, informe de registro de asistentes, informe de registros de actividad del administrador e informe de inicio y cierre de sesión"
    },
    "close": "Cerrar"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Su {planName} se cancelará el {cancelDate}. Antes de esa fecha, podrá reactivar sus licencias de seminarios web. Del {supportStartDate} al {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para acceder a los datos de los seminarios web disponibles. Después del {dataLossDate}, perderá todos los datos de los seminarios web.",
            "nonAdmin": "Su {planName} se cancelará el {cancelDate}. Antes de esa fecha, podrá ponerse en contacto con el administrador de su cuenta para reactivar sus licencias de seminarios web. Del {supportStartDate} al {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para acceder a los datos de los seminarios web disponibles. Después del {dataLossDate}, perderá todos los datos de los seminarios web de su cuenta."
          },
          "admin": "Su {planName} se cancelará el {cancelDate}. Antes de esa fecha, podrá reactivar sus licencias de seminarios web. Desde el {supportStartDate} hasta el {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para acceder a {supportContent} de los seminarios web disponibles. Después del {dataLossDate}, perderá todos los datos de los seminarios web de su cuenta.",
          "nonAdmin": "Su {planName} se cancelará el {cancelDate}. Antes de esa fecha, podrá ponerse en contacto con el administrador de su cuenta para reactivar sus licencias de seminarios web. Desde el {supportStartDate} hasta el {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para acceder a {supportContent} de los seminarios web disponibles. Después del {dataLossDate}, perderá todos los datos de los seminarios web de su cuenta."
        },
        "expired": {
          "admin": "Su {planName} está cancelado. Desde el {supportStartDate} hasta el {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para acceder a {supportContent} de los seminarios web disponibles, o volver a comprar Zoom Webinars para restaurar el acceso a los datos. Después del {dataLossDate}, perderá todos los datos de los seminarios web de su cuenta.",
          "nonAdmin": "Su {planName} está cancelado. Desde el {supportStartDate} hasta el {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para acceder a {supportContent} de los seminarios web disponibles, o con el administrador de la cuenta para volver a comprar Zoom Webinars y restaurar el acceso a los datos. Después del {dataLossDate}, perderá todos los datos de los seminarios web de su cuenta."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Su {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante ese periodo, solo podrá ver los seminarios web disponibles y sus activos. No dude en eliminar la pausa y reanudar la suscripción a sus licencias de seminarios web en cualquier momento.",
            "nonAdmin": "Su {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante ese tiempo, solo podrá ver los seminarios web disponibles y sus activos. Puede ponerse en contacto con el administrador de su cuenta para eliminar la pausa y reanudar la suscripción de sus licencias de seminarios web en cualquier momento."
          },
          "admin": "Su {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante ese tiempo, solo podrá ver {supportContent}. No dude en eliminar la pausa y reanudar la suscripción a sus licencias de seminarios web en cualquier momento.",
          "nonAdmin": "Su {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante ese tiempo, solo podrá ver {supportContent}. Puede ponerse en contacto con el administrador de su cuenta para eliminar la pausa y reanudar la suscripción de sus licencias de seminarios web en cualquier momento."
        },
        "active": {
          "webinars": {
            "admin": "Su {planName} está en pausa durante {pauseDuration} a partir del {pausedDate}. Durante ese tiempo, solo podrá ver los seminarios web disponibles. No dude en reanudar la suscripción a sus licencias de seminarios web en cualquier momento.",
            "nonAdmin": "Su {planName} está en pausa durante {pauseDuration} a partir del {pausedDate}. Durante ese tiempo, solo podrá ver los seminarios web disponibles. No dude en ponerse en contacto con el administrador de su cuenta para reanudar la suscripción a sus licencias de seminarios web en cualquier momento."
          },
          "admin": "Su {planName} está en pausa durante {pauseDuration}. Durante ese tiempo, solo podrá consultar {supportContent} de los seminarios web disponibles. No dude en reanudar la suscripción a sus licencias de seminarios web en cualquier momento.",
          "nonAdmin": "Su {planName} está en pausa durante {pauseDuration}. Durante ese tiempo, solo podrá consultar {supportContent} de los seminarios web disponibles. No dude en ponerse en contacto con el administrador de su cuenta para reanudar la suscripción a sus licencias de seminarios web en cualquier momento."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Su licencia de {planName} se pausará el {pausedDate} durante {pauseDuration}. Para continuar organizando seminarios web, asigne una licencia activa a este usuario antes de que la pausa surta efecto. También puede quitar la pausa para seguir utilizando esta licencia.",
            "nonAdmin": "Su licencia de {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante el periodo de pausa, solo podrá ver los seminarios web existentes y sus activos. Para continuar organizando seminarios web, póngase en contacto con el administrador de su cuenta para que asigne una licencia activa a su cuenta antes de que la pausa surta efecto."
          },
          "active": {
            "admin": "Su licencia de {planName} está en pausa durante {pauseDuration} a partir del {pausedDate}. Durante la pausa, solo podrá ver los seminarios web existentes. No dude en reanudar la suscripción a la licencia o asignar una licencia activa a su cuenta para continuar organizando seminarios web.",
            "nonAdmin": "Su licencia de {planName} está en pausa durante {pauseDuration} a partir del {pausedDate}. Durante la pausa, solo podrá ver los seminarios web existentes. Para organizar seminarios web durante la pausa, póngase en contacto con el administrador de su cuenta para que asigne una licencia activa a su cuenta."
          }
        },
        "cancel": {
          "active": {
            "admin": "Su licencia de {planName} se cancelará el {cancelDate}. Para seguir organizando seminarios web, reactive su licencia de seminarios web o asigne una licencia activa antes de que la cancelación entre en vigor. Si no se toma ninguna medida, tendrá un periodo de gracia del {supportStartDate} al {supportEndDate} para ponerse en contacto con el Soporte al cliente y recuperar los datos de los seminarios web existentes. Después del {dataLossDate}, se eliminarán de forma permanente todos los datos de seminarios web asociados a su cuenta.",
            "nonAdmin": "Su licencia de {planName} se cancelará el {cancelDate}. Para seguir organizando seminarios web, póngase en contacto con el administrador de su cuenta para reactivar su licencia de seminarios web o asignar una licencia activa antes de que la cancelación entre en vigor. Si no se toma ninguna medida, tendrá un periodo de gracia del {supportStartDate} al {supportEndDate} para ponerse en contacto con el Soporte al cliente y recuperar los datos de los seminarios web existentes. Después del {dataLossDate}, se eliminarán de forma permanente todos los datos de seminarios web asociados a su cuenta."
          },
          "expired": {
            "admin": "Se ha cancelado su licencia de {planName}. Para continuar organizando seminarios web, asigne una licencia activa a este usuario. Del {supportStartDate} al {supportEndDate}, puede ponerse en contacto con el Soporte al cliente para recuperar los datos de seminarios web existentes.",
            "nonAdmin": "Se ha cancelado su licencia de {planName}. Para continuar organizando seminarios web, póngase en contacto con el administrador de su cuenta para que asigne una licencia activa a su perfil. Del {supportStartDate} al {supportEndDate}, póngase en contacto con el Soporte al cliente para recuperar los datos existentes de los seminarios web."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Su licencia de {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante el periodo de pausa, solo podrá ver {supportContent} de los seminarios web anteriores. Para seguir accediendo a los activos de los seminarios web, asigne una licencia activa a este usuario antes de que la pausa surta efecto. También puede quitar la pausa para seguir utilizando esta licencia.",
              "nonAdmin": "Su licencia de {planName} se pausará el {pausedDate} durante {pauseDuration}. Durante el periodo de pausa, solo podrá ver {supportContent}. Para seguir accediendo a los activos de los seminarios web, póngase en contacto con el administrador de su cuenta para que asigne una licencia activa a su perfil."
            },
            "active": {
              "admin": "Su {planName} está en pausa durante {pauseDuration} a partir del {pausedDate}. Durante la pausa, solo podrá ver las {supportContent} de los seminarios web existentes. Para seguir accediendo a los activos de los seminarios web, asigne una licencia activa a su cuenta. También puede reanudar la suscripción a esta licencia en cualquier momento.",
              "nonAdmin": "Su {planName} está en pausa durante {pauseDuration} a partir del {pausedDate}. Durante la pausa, solo podrá ver las {supportContent} de los seminarios web existentes. Para organizar seminarios web durante la pausa, póngase en contacto con el administrador de su cuenta para que asigne una licencia activa a su cuenta."
            }
          },
          "cancel": {
            "active": {
              "admin": "Su {planName} se cancelará el {cancelDate}. Para continuar organizando seminarios web, asigne una licencia activa a su cuenta antes de que la cancelación entre en vigor. Puede reactivar esta licencia antes del {cancelDate}. Desde el {supportStartDate} hasta el {supportEndDate}, podrá ponerse en contacto con el Soporte al cliente para recuperar las {supportContent} de los seminarios web existentes.",
              "nonAdmin": "Su licencia de {planName} se cancelará el {cancelDate}. Para seguir organizando seminarios web, póngase en contacto con el administrador de su cuenta para reactivar su licencia de seminarios web o asignar una licencia activa antes de que la cancelación entre en vigor. Si no se toma ninguna medida, tendrá un periodo de gracia del {supportStartDate} al {supportEndDate} para ponerse en contacto con el Soporte al cliente y recuperar {supportContent} de los seminarios web existentes. Después del {dataLossDate}, se eliminarán de forma permanente todos los datos de seminarios web asociados a su cuenta."
            },
            "expired": {
              "admin": "Se ha cancelado su licencia de {planName}. Para continuar organizando seminarios web, asigne una licencia activa a este usuario. Del {supportStartDate} al {supportEndDate}, póngase en contacto con el Soporte al cliente para recuperar las {supportContent} de los seminarios web existentes.",
              "nonAdmin": "Se ha cancelado su licencia de {planName}. Para continuar organizando seminarios web, póngase en contacto con el administrador de su cuenta para que asigne una licencia activa a su perfil. Del {supportStartDate} al {supportEndDate}, póngase en contacto con el Soporte al cliente para recuperar las {supportContent} de los seminarios web existentes."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "datos",
        "recordingsAndTranscripts": "grabaciones y transcripciones",
        "reports": "informes",
        "summaries": "resúmenes",
        "dashboard": "paneles de control"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "grabaciones y transcripciones de seminarios web anteriores",
          "reports": "informes de seminarios web anteriores",
          "summaries": "resúmenes de seminarios web anteriores",
          "dashboard": "paneles de control de seminarios web anteriores",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Reactivar plan",
    "purchasePlan": "Comprar plan",
    "removePause": "Eliminar pausa",
    "resumeSubscription": "Reanudar suscripción",
    "month": "mes",
    "months": "meses",
    "assignLicense": "Asignar licencia"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Entendido"
    },
    "coachMark": {
      "tipsTitle": "La libreta de direcciones pasará a ser el directorio de clientes",
      "tipsContent": "En la versión de octubre de 2026, cambiaremos el nombre de Libreta de direcciones a Directorio de clientes para reflejar mejor su finalidad. Toda la funcionalidad, los permisos y los flujos de trabajo existentes permanecerán igual: seguirá administrando las listas de clientes (libretas de direcciones) y los contactos como lo hace ahora."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Estamos actualizando los términos y las políticas",
    "agreeSub": "Al continuar usando Zoom, acepta los <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Términos del servicio</a> y la <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Política de privacidad</a>.",
    "continue": "Continuar"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Volver a la cuenta principal",
      "backLinkedAccount": "Volver a la cuenta vinculada",
      "backMyAccount": "Volver a Mi cuenta",
      "myAccount": "Mi cuenta"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion ya está disponible para su cuenta",
      "desc": "Estas son algunas de las funciones de Custom AI Companion que puede usar en su cuenta:",
      "studioTitle": "AI Studio",
      "studioDesc": "Personalice la experiencia de AI Companion para su organización.",
      "integrationsTitle": "Integraciones de terceros",
      "integrationsDesc": "Aproveche las aplicaciones de terceros para agilizar sus flujos de trabajo.",
      "clipsTitle": "Avatares personalizados para Zoom Clips",
      "clipsDesc": "Permita que los usuarios personalicen avatares de IA para usarlos en sus clips."
    },
    "coachMark": {
      "licenseTitle": "Tiene {0} licencias de Custom AI Companion para asignar",
      "licenseDesc": "Asigne estas licencias en <b>Gestión de usuarios</b> para que sus usuarios puedan empezar a usar las funciones avanzadas de AI Companion.",
      "settingTitle": "Consulte la configuración de Custom AI Companion de su cuenta",
      "settingDesc": "Configure cada función de Custom AI en <b>Configuración de la cuenta</b>. <a href=\"/account/setting?tab=aicompanion\">Ir a la configuración</a>",
      "groupSettingTitle": "Consulte la configuración de Custom AI de su grupo",
      "groupSettingDesc": "Configure cada función de Custom AI en <b>Configuración del grupo</b>. <a href=\"/account/group\">Ir a la configuración</a>"
    },
    "common": {
      "learnMore": "Más información",
      "quickTour": "Hacer un recorrido rápido",
      "remindLater": "Recordármelo más tarde",
      "dismiss": "Cerrar",
      "next": "Siguiente",
      "back": "Atrás",
      "gotIt": "Entendido",
      "goToSetting": "Ir a la configuración"
    },
    "aiPanelToast": "Active la configuración <b>Panel de IA en Zoom Workplace</b> para empezar a usar todas las funciones de Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Entendido",
      "next": "Siguiente",
      "remindMeLater": "Recordármelo más tarde",
      "waffleMenuTitle": "Bienvenido a la nueva experiencia web de Zoom",
      "waffleMenuDesc": "Acceda a los productos de Zoom desde cualquier lugar con nuestro nuevo <b>menú de productos.</b>",
      "profileMenuTitle": "Mi cuenta",
      "profileMenuDesc": "Encuentre su perfil y su configuración personal en <b>Mi cuenta.</b>",
      "personalTitle": "Acceda a todo lo que necesita",
      "personalDesc": "<b>Mi cuenta</b> incluye su perfil, la configuración, las transcripciones de reuniones y más.",
      "adminCenterTitle": "Encuentre la configuración de la organización en el Centro de administración",
      "adminCenterDesc": "Su nuevo <b>Centro de administración</b> le permite configurar productos y ajustar la configuración de toda su organización.",
      "adminMenuForTitle": "Use el Centro de administración como un profesional",
      "adminMenuForAccountSettings": "<b>Configuración</b> le permite acceder a la configuración predeterminada de los productos para todos los miembros de su organización.",
      "adminMenuForContentManagementItem": "En <b>Gestión de contenido</b> puede administrar todo el contenido generado por los usuarios.",
      "adminMenuForConfigureProductsItem": "<b>Configuración de productos</b> le permite configurar sus productos y completar las tareas de administrador.",
      "adminMenuForNoItems": "El nuevo centro de administración le permite acceder y administrar con más facilidad la configuración de su cuenta y sus productos. También puede anclar los elementos que desee para acceder a ellos más rápido.",
      "tryNewExperience": "Probar la nueva experiencia",
      "tryNewExperienceDetail": "¡Pruébela! Siempre puede volver a esta experiencia clásica.",
      "tryNewExperienceTitle": "¡Nueva apariencia de Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Todos los derechos reservados.",
    "terms": "Términos",
    "privacy": "Privacidad",
    "trust_center": "Centro de confianza",
    "acceptable_use_guidelines": "Directrices de uso aceptable",
    "legal": "Legal",
    "do_not_sell_my_personal_information": "Sus opciones de privacidad",
    "cookie_preferences": "Preferencias de cookies",
    "pricing": "Planes y precios",
    "feedback": "Comentarios",
    "contact_us": "Contacto"
  },
  "termChange": {
    "changeTerm": {
      "title": "Acuerdo de cambio del plazo de renovación",
      "quoteNumbers": "Formulario(s) de pedido modificado(s) - {0}",
      "content1": "Al aceptar estos términos, el Cliente acepta modificar el plazo de renovación de suscripción existente de todos los formularios de pedido entre Zoom Communications, Inc. (“Zoom”) y el Cliente, cambiando el plazo comprometido de una renovación mensual a un {0}. A cambio de este compromiso, Zoom acepta mantener los precios actuales del Cliente durante el primer nuevo plazo de renovación.",
      "content2": "El Cliente entiende que el nuevo plazo de renovación de {0} se aplica en cuanto el Cliente haga clic en “Acepto” a continuación, y que el nuevo plazo de renovación comenzará el día siguiente al final del plazo de renovación mensual actual del Cliente. Este nuevo plazo de renovación se aplicará a todos los formularios de pedido actualmente vigentes con Zoom, y todos los plazos de renovación futuros de dichos formularios de pedido tendrán la misma duración.",
      "content3": "El Cliente reconoce que el único cambio que se realiza es el del plazo de renovación, y que el resto de los términos y condiciones de cada formulario de pedido actualmente vigente con Zoom permanecen inalterados y en pleno vigor de conformidad con sus términos.",
      "content4": "Además, usted acepta que se trata de un compromiso contractual entre el Cliente y Zoom.",
      "agreementText": "Al hacer clic en “Acepto”, certifica que está autorizado para realizar este cambio en nombre del Cliente, y que el Cliente acepta los términos y condiciones detallados arriba.",
      "IDecline": "Rechazo",
      "IAccept": "Acepto"
    },
    "unableToChangeTerm": {
      "title": "No se puede cambiar el plazo de renovación",
      "content": "Su cuenta no es apta para actualizar el plazo de renovación. <a target=\"_blank\" href=\"{0}\">Contáctenos</a> si se trata de un error.",
      "acceptedTitle": "Plazo de renovación prorrogado",
      "acceptedContent": "Ya aceptó anteriormente los términos de renovación. No se requiere ninguna otra acción.",
      "GotIt": "Entendido"
    },
    "termLengthUpdated": "La duración del plazo de renovación se actualizó a {0} meses.",
    "termLengthUnchanged": "La duración del plazo no ha cambiado.",
    "errorInfo": "Se produjo un error del servidor. Inténtelo de nuevo.",
    "x12MonthTerm": "plazo de doce (12) meses",
    "x24MonthTerm": "plazo de veinticuatro (24) meses",
    "x12MonthTermPlural": "doce (12) meses",
    "x24MonthTermPlural": "veinticuatro (24) meses"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Su cuenta está programada para actualizarse a la <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nueva experiencia web de Zoom</a> el {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Revisar cuándo actualizar</a>"
    },
    "completed": {
      "content": "La nueva experiencia web de Zoom ya está activa para todos los usuarios de su cuenta. Los usuarios verán la interfaz actualizada en el próximo inicio de sesión."
    }
  }
}
